import { render, staticRenderFns } from "./CreateNoRealTaskDialog2.vue?vue&type=template&id=dd9de524&"
import script from "./CreateNoRealTaskDialog2.vue?vue&type=script&lang=js&"
export * from "./CreateNoRealTaskDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports